export const GET_MUSEUMS = "GET_MUSEUMS";
export const GET_MUSEUM = "GET_MUSEUM";
export const SET_DATA = "SET_DATA";
export const SET_MUSEUM = "SET_MUSEUM";
export const SET_RECOMMENDATION = "SET_RECOMMENDATION";
export const GET_RECOMMENDATION = "GET_RECOMMENDATION";
